(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ReceiptFileSearch', ReceiptFileSearch);

  ReceiptFileSearch.$inject = ['$resource', 'API_URI'];

  function ReceiptFileSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/receipt-files/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
